import { showNotification } from '@helpers/notification-helper';
import { PlusOutlined } from '@icon';
import { addGuarantor } from '@services/external/provider.api';
import { Button, Divider, Drawer, Form, MessageBox, TextField } from '@ui';
import React from 'react';
import { useTheme } from 'styled-components';
import { initialValues, validationSchema } from './add-guarantor-modal.schema';
import { FormSC } from './add-guarantor-modal.styled';

interface AddGuarantorModalProps {
  afterSubmit?: () => void;
  providerId: string;
}

const AddGuarantorModal: React.FunctionComponent<AddGuarantorModalProps> = ({
  afterSubmit,
  providerId,
}) => {
  const theme = useTheme();
  const { drawerProps, open, close } = Drawer.useDrawer();

  const [, formProps] = Form.useForm({
    initialValues,
    validationSchema,
    onSubmit: async (v) => {
      try {
        await addGuarantor(providerId, v);
        afterSubmit?.();
        showNotification({ title: 'Zodpovedná osoba pridaná', copy: '', type: 'SUCCESS' });
      } catch (error) {
        console.log(error);
        showNotification({ title: 'Niečo sa pokazilo', copy: '', type: 'ERROR' });
      }
    },
  });

  return (
    <>
      <Drawer onClose={close} {...drawerProps} title="Pridanie zodpovednej osoby">
        <FormSC {...formProps} showFeedback>
          <Drawer.Description>
            Pridajte garanta zdravotníckeho zariadenia s lekárskym kódom
          </Drawer.Description>
          <Form.Field name="firstName" label="Meno" required>
            <TextField />
          </Form.Field>
          <Form.Field name="lastName" label="Priezvisko" required>
            <TextField />
          </Form.Field>
          <Form.Field name="phoneNumber" label="Tel. č." required>
            <TextField autoComplete="tel" type="tel" />
          </Form.Field>
          <Form.Field name="email" label="E-mail" required>
            <TextField type="email" autoComplete="email" />
          </Form.Field>
          <Form.Field name="doctorCode" label="Kód lekára" required>
            <TextField />
          </Form.Field>
          <Form.Custom>
            {(f) => (
              <Button
                type="submit"
                loading={f.isSubmitting}
                style={{ marginTop: theme.spacings.component.M }}
              >
                Pridať
              </Button>
            )}
          </Form.Custom>
        </FormSC>
      </Drawer>
      <MessageBox
        title="Poskytujete medicínske služby?"
        description={
          <>
            Ak ste poskytovateľom medicínskych služieb, pridajte si <b>Zodpovednú osobu</b>, aby ste
            mohli vykonávať medicínske špecializácie.
          </>
        }
        footer={
          <Button variant="primary" block={false} size="small" Icon={PlusOutlined} onClick={open}>
            Pridať Zodpovednú osobu
          </Button>
        }
      />
      <Divider style={{ padding: `${theme.spacings.component.M}px 0` }} />
    </>
  );
};

export default AddGuarantorModal;
